import { apiClient } from '../axios-instance'
import type { Order, OrderFilters, UpdateStatusRequest, CancelOrderRequest } from '@/features/orders/types/order.types'

export interface PaginatedResponse<T> {
    success: boolean
    data: T[]
    pagination: {
        total: number
        per_page: number
        current_page: number
        last_page: number
    }
    statistics?: {
        total_orders: number
        total_revenue: string
        delivered_orders: number
    }
}

export const ordersService = {
    getOrders: async (filters?: OrderFilters) => {
        const response = await apiClient.get<PaginatedResponse<Order>>('/admin/orders', { params: filters })
        // Return raw response to let hook handle structure or map here? 
        // Let's map stats here to be cleaner for hook?
        // Actually, returning full data structure is better flexibility.
        return {
            ...response.data,
            statistics: response.data.statistics ? {
                totalOrders: response.data.statistics.total_orders,
                totalRevenue: Number(response.data.statistics.total_revenue),
                deliveredOrders: response.data.statistics.delivered_orders
            } : undefined
        }
    },

    getOrderById: async (id: number | string) => {
        const response = await apiClient.get<{ success: boolean; data: Order }>(`/admin/orders/${id}`)
        return response.data.data
    },

    updateStatus: async (id: number | string, data: UpdateStatusRequest) => {
        const response = await apiClient.put<{ success: boolean; data: Order }>(`/admin/orders/${id}/status`, data)
        return response.data.data
    },

    cancelOrder: async (id: number | string, data: CancelOrderRequest) => {
        const response = await apiClient.post<{ success: boolean; data: Order }>(`/admin/orders/${id}/cancel`, data)
        return response.data.data
    },

    getOrderTimeline: async (id: number | string) => {
        const response = await apiClient.get<{ success: boolean; data: any[] }>(`/admin/orders/${id}/timeline`)
        return response.data.data
    },
    
    exportOrders: async (filters?: OrderFilters) => {
        const response = await apiClient.get('/admin/orders/export', { 
            params: filters,
            responseType: 'blob' 
        })
        return response.data
    },

    getStatistics: async (filters?: OrderFilters) => {
        const response = await apiClient.get<{ success: boolean; data: any }>('/admin/orders/statistics', { params: filters })
        const stats = response.data.data
        return {
            totalOrders: stats.total_orders,
            totalRevenue: Number(stats.total_revenue),
            deliveredOrders: stats.delivered_orders
        }
    }
}
